import React from "react";
import { Timestamp } from "firebase/firestore";
import NavBar from "../../components/feature/NavBar";
import BoardsHeader from "../../components/feature/BoardsHeader";
import BoardsMap from "../../components/feature/BoardsMap";
import Footer from "../../components/feature/Footer";


interface Picture {
    id: string;
    url: string;
    reference: string;
    createdAt: Timestamp;
}

export interface Board {
  id: string;
  picture: Picture;
  createdAt: Timestamp;
}

const Boards: React.FC = () => {
  return (
    <div className="min-h-screen bg-neutral-50 text-gray-800 md:px-20 px-8">
      <NavBar />
      <BoardsHeader/>
      <BoardsMap/>
      <Footer />
    </div>
  );
};

export default Boards;